export default __webpack_public_path__ + "static/media/IMG_6069 copy - Copy.1186a0b0.jpg";